import * as React from 'react';
import {
  TextAction,
  useMediaQuery,
  queryHelpers,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { Link, useNavigate } from 'react-router-dom';
import { HeaderNavBar, DesktopNav } from '@leagueplatform/solutions-foundation';
import { EVENT_NAME, trackAnalyticsEvent } from '@leagueplatform/analytics';
import logoWithText from 'assets/ptth-logo.svg';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { useUserSettingsLinksConfig } from 'components/header-nav/use-user-settings-links-config.hook';
import { DeactivateAccountDialog } from './deactivate-account-dialog.component';
import { AccountDeactivatedDialog } from './account-deactivated-dialog.component';
import { useNavLinksList } from './use-nav-links-list.hook';
import { CustomMobileNav } from './mobile-nav-drawer.component';

const Logo = () => {
  const { formatMessage } = useIntl();
  return (
    <TextAction
      as={Link}
      to={APP_MANAGED_ROUTES.HOME}
      onClick={() =>
        // TODO: Verify correct analytics parameters
        trackAnalyticsEvent(EVENT_NAME.NAVIGATION_TAB_CLICKED, {
          screen_name: 'Navigation Bar',
          product_area: 'Navigation Bar',
          detail: 'Nav Bar Logo clicked',
          sub_detail: APP_MANAGED_ROUTES.HOME,
        })
      }
    >
      <img
        src={logoWithText}
        height="32px"
        alt={formatMessage({ id: 'STR_APP_NAME' })}
      />
    </TextAction>
  );
};

export const AppNavBarComponent = React.memo(() => {
  const { navLinks } = useNavLinksList();
  const { userMenu, modal, setModal } = useUserSettingsLinksConfig();
  const isMobile = useMediaQuery(queryHelpers.down('tablet'));
  const navigate = useNavigate();

  return (
    <>
      <HeaderNavBar>
        {isMobile ? (
          <CustomMobileNav
            navLinks={navLinks}
            userMenu={userMenu}
            logo={<Logo />}
          />
        ) : (
          <DesktopNav navLinks={navLinks} userMenu={userMenu} logo={<Logo />} />
        )}
      </HeaderNavBar>
      {modal === 'deactivate' && (
        <DeactivateAccountDialog
          onClose={() => setModal(null)}
          onConfirm={() => setModal('deactivated')}
        />
      )}
      {modal === 'deactivated' && (
        <AccountDeactivatedDialog
          onClose={() => navigate(APP_MANAGED_ROUTES.SIGN_OUT)}
        />
      )}
    </>
  );
});
